import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { AssessmentData } from './ContainAssessment';
import { GRADIENTS } from '../../../config/designSystem/Colors';
import { PresentAssessment } from './PresentAssessment';

const SCALE = ['Very poor', 'Poor', 'Okay', 'Very good', 'Excellent'];

const data = (value: number, onChangeValue: (value: number) => void = () => undefined): AssessmentData => ({
  scale: SCALE,
  value,
  onChangeValue,
  gradient: GRADIENTS.modules.LAVENDER,
});

const meta = {
  title: 'Diary/Frames/Assessment',
  component: PresentAssessment,
  args: {
    questionId: 'story-assessment',
    questionText: 'How are you today?',
    margin: 16,
    data: data(2),
  },
  decorators: [
    Story => (
      <View style={{ width: 375, height: 640 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof PresentAssessment>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Okay: Story = {};

const InteractiveAssessment = (args: React.ComponentProps<typeof PresentAssessment>) => {
  const [value, setValue] = useState(2);
  return (
    <View style={{ width: 375, height: 640 }}>
      <PresentAssessment {...args} data={data(value, setValue)} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveAssessment {...args} />,
};
